const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Card/styles.ts';
import { css } from '@emotion/css';
import { theme } from 'App/utils/clientSetupManager';

export const cssFlexBoxStyle = css`
    display: flex;
`;

export const iconStyle = css`
    margin-top: ${theme.spacing(1)};
    color: ${theme.palette.primary.main};
`;

export const cssDefaultCursor = css`
    cursor: default;
`;
